import { createGlobalStyle } from "styled-components";

/**
 * GlobalStyles
 * - Writes CSS variables from the active theme on every theme change
 * - Provides sane fallbacks to avoid FOUC and crashes
 */
export const GlobalStyles = createGlobalStyle`
  :root {
    /* Core palette */
    --theme1_primary:     ${({ theme }) => theme?.colors?.primary     ?? "#3b82f6"};
    --theme1_secondary:   ${({ theme }) => theme?.colors?.secondary   ?? "#60a5fa"};
    --theme1_tertiary:    ${({ theme }) => theme?.colors?.tertiary    ?? "#93c5fd"};
    --theme1_quarternary: ${({ theme }) => theme?.colors?.quarternary ?? "#c7d2fe"};

    /* Actual UI surface + text (you had both pointing to quarternary earlier) */
    --card_body_color:    ${({ theme }) => theme?.colors?.body        ?? "#ffffff"};
    --text_color:         ${({ theme }) => theme?.colors?.text        ?? "#111827"};

    --rs-toggle-bg:           #3c3f43;
    --rs-toggle-disabled-bg:  lightgray;
    --rs-toggle-checked-bg: ${({ theme }) => theme?.colors?.secondary ?? "#60a5fa"};

    /* Typographic scale */
    --small_font:   8px;
    --default:     12px;
    --h1:         50px;
    --h2:         40px;
    --h3:         30px;
    --h4:         24px;
    --h5:         18px;
    --h6:         14px;
    --h7:         12px;

    /* Image tokens */
    --small_image:  20px;
    --medium_image: 50px;
    --large_image: 100px;

    // /* Optional additional tokens if you use them elsewhere */
    // --btn_bg:   ${({ theme }) => theme?.colors?.button?.background ?? "var(--theme1_primary)"};
    // --btn_text: ${({ theme }) => theme?.colors?.button?.text       ?? "var(--card_body_color)"};
    // --link_text: ${({ theme }) => theme?.colors?.link?.text        ?? "var(--theme1_secondary)"};
    // --link_opacity: ${({ theme }) => (theme?.colors?.link?.opacity ?? 1)};
  }

  // /* Paint base surfaces using the vars  */
  // html, body {
  //   background: var(--card_body_color);
  //   color: var(--text_color);
  // }

  // /* Give common panels a base */
  // .card, .modal, .offcanvas, .dropdown-menu, .ag-theme-quartz {
  //   background: var(--card_body_color);
  //   color: var(--text_color);
  // }

  // a { color: var(--link_text); opacity: var(--link_opacity); }
  // button, .btn { background: var(--btn_bg); color: var(--btn_text); 
  
  }
`;
